import { IconProps } from ".";
import Icon from "./assets/book_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Book(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
